/**
 * Builds matrix route matcher that matches a matrix attribute.
 *
 * @param name - Required matrix attribute.
 * @param value - A value the attribute should have. Or nothing to just require the attribute to present.
 *
 * @returns New URL route matcher.
 */
export function rmatchMatrixAttr(name, value) {
    const condition = value == null ? attrs => attrs.has(name) : attrs => attrs.getAll(name).includes(value);
    return {
        test: ({ entry: { attrs } }) => condition(attrs) && { nameChars: 0 },
    };
}
//# sourceMappingURL=rmatch-matrix-attr.js.map